const defaultAmplifyConfig = {
	aws_project_region: 'us-east-2',
	aws_cognito_identity_pool_id: 'us-east-2:43d2d160-5ca1-4b5e-9e3a-a1513238d132',
	aws_cognito_region: 'us-east-2',
	aws_user_pools_id: 'us-east-2_huCRyNvO6',
	aws_user_pools_web_client_id: '66qelm8iem6vm4mvvo1fjcv8cm',
	oauth: {},
	aws_user_files_s3_bucket: 'ccv3-offline-s3-photostorage-sssdev',
	aws_user_files_s3_bucket_region: 'us-east-2',
	aws_appsync_graphqlEndpoint:
		'https://qqqqrfhrz5cp3aberjgr5si2te.appsync-api.us-east-2.amazonaws.com/graphql',
	aws_appsync_region: 'us-east-2',
	aws_appsync_authenticationType: 'AWS_IAM',
}

function fromEnv(...keys) {
	for (const key of keys) {
		if (process.env[key]) {
			return process.env[key]
		}
	}

	return undefined
}

const amplifyConfig = {
	aws_project_region:
		fromEnv('GATSBY_AWS_PROJECT_REGION') || defaultAmplifyConfig.aws_project_region,
	aws_cognito_identity_pool_id:
		fromEnv('GATSBY_AWS_COGNITO_IDENTITY_POOL_ID') ||
		defaultAmplifyConfig.aws_cognito_identity_pool_id,
	aws_cognito_region:
		fromEnv('GATSBY_AWS_COGNITO_REGION') || defaultAmplifyConfig.aws_cognito_region,
	aws_user_pools_id:
		fromEnv('GATSBY_AWS_USER_POOLS_ID') || defaultAmplifyConfig.aws_user_pools_id,
	aws_user_pools_web_client_id:
		fromEnv('GATSBY_AWS_USER_POOLS_WEB_CLIENT_ID') ||
		defaultAmplifyConfig.aws_user_pools_web_client_id,
	oauth: defaultAmplifyConfig.oauth,
	aws_user_files_s3_bucket:
		fromEnv('GATSBY_AWS_USER_FILES_S3_BUCKET') ||
		defaultAmplifyConfig.aws_user_files_s3_bucket,
	aws_user_files_s3_bucket_region:
		fromEnv('GATSBY_AWS_USER_FILES_S3_BUCKET_REGION') ||
		defaultAmplifyConfig.aws_user_files_s3_bucket_region,
	aws_appsync_graphqlEndpoint:
		fromEnv('GATSBY_AWS_APPSYNC_GRAPHQL_ENDPOINT', 'GATSBY_APPSYNC_GRAPHQL_ENDPOINT') ||
		defaultAmplifyConfig.aws_appsync_graphqlEndpoint,
	aws_appsync_region:
		fromEnv('GATSBY_AWS_APPSYNC_REGION', 'GATSBY_APPSYNC_REGION') ||
		defaultAmplifyConfig.aws_appsync_region,
	aws_appsync_authenticationType:
		fromEnv('GATSBY_AWS_APPSYNC_AUTHENTICATION_TYPE', 'GATSBY_APPSYNC_AUTHENTICATION_TYPE') ||
		defaultAmplifyConfig.aws_appsync_authenticationType,
}

const amplifyConfigWarnings = []

export { amplifyConfig, amplifyConfigWarnings }

export default amplifyConfig